"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatMoleculeStructuresInner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ChartContext_1 = require("../../../context/ChartContext");
const useSpectrum_1 = __importDefault(require("../../../hooks/useSpectrum"));
const assert_1 = require("../../../utility/assert");
const DraggableStructure_1 = require("./DraggableStructure");
function FloatMoleculeStructuresInner(props) {
    const { zones, ranges, moleculesView, molecules, activeTab, displayerMode } = props;
    const floatingMolecules = Object.entries(moleculesView);
    if (floatingMolecules.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: floatingMolecules
            .filter(([, view]) => view.floating.visible)
            .map(([id, moleculeView], index) => {
            const molecule = molecules.find((m) => m.id === id);
            (0, assert_1.assert)(molecule !== undefined, 'molecule should be defined');
            return ((0, jsx_runtime_1.jsx)(DraggableStructure_1.DraggableStructure, { zones,
                ranges,
                activeTab,
                displayerMode,
                moleculeView,
                molecule,
                index }, id));
        }) }));
}
exports.FloatMoleculeStructuresInner = FloatMoleculeStructuresInner;
const MemoizedFloatMoleculeStructures = (0, react_1.memo)(FloatMoleculeStructuresInner);
const emptyData = { ranges: {}, zones: {} };
function FloatMoleculeStructures() {
    const { molecules, displayerMode, view: { molecules: moleculesView, spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const data = (0, useSpectrum_1.default)(emptyData);
    const ranges = data?.ranges || {};
    const zones = data?.zones || {};
    return ((0, jsx_runtime_1.jsx)(MemoizedFloatMoleculeStructures, { moleculesView,
        molecules,
        displayerMode,
        activeTab,
        ranges,
        zones }));
}
exports.default = FloatMoleculeStructures;
